import { p as proxyCustomElement, H, c as createEvent, h } from './p-BJEvNVLM.js';
import { j as getDefaultSlotTextContent, s as slotMutationService, b as bem } from './p-g1JgJ7wn.js';
import { t as transformTagName, r as resolveAppearance } from './p-CkrRd9Ud.js';
import { d as defineCustomElement$2 } from './p-BMLmP8GU.js';

const cosmosRadioCss = "@charset \"UTF-8\";:host{display:block;min-width:0;width:100%}.cosmos-radio{align-items:baseline;display:flex}.cosmos-radio__input-and-prefix{align-items:center;display:flex;flex-shrink:0}.cosmos-radio__aligner{--cosmos-text-font-family:var(--cosmos-radio-font-family);--cosmos-text-font-size:var(--cosmos-radio-font-size);--cosmos-text-font-style:var(--cosmos-radio-font-style);--cosmos-text-font-weight:var(--cosmos-radio-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-line-height);--cosmos-text-text-transform:var(--cosmos-radio-text-transform);width:0}.cosmos-radio__aligner::before{content:\" \"}.cosmos-radio__input-container{align-items:center;display:flex;flex-shrink:0;height:var(--cosmos-radio-size, 16px);justify-content:center;margin-inline-end:var(--cosmos-radio-gap, calc(0.5 * var(--cosmos-radio-size, 16px)));position:relative;width:var(--cosmos-radio-size, 16px)}.cosmos-radio__prefix{display:grid}.cosmos-radio__prefix>[slot=prefix]{margin-inline-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)))}.cosmos-radio__prefix ::slotted([slot=prefix]){--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px;margin-inline-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)));position:relative}.cosmos-radio__prefix ::slotted([slot=prefix])::before{content:\"\";display:block;height:100%;left:0;min-height:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);position:absolute;right:0;top:50%;transform:translateY(-50%)}.cosmos-radio__input{align-items:center;-webkit-appearance:none;appearance:none;background:none;border-radius:9999px;border-style:solid;border-width:var(--cosmos-radio-border-width, 1px);box-shadow:none;box-sizing:border-box;display:flex;height:var(--cosmos-radio-size, 16px);justify-content:center;margin:0;outline:none;padding:0;width:var(--cosmos-radio-size, 16px)}.cosmos-radio__input:focus,.cosmos-radio__input:focus:not(:focus-visible){outline:none}.cosmos-radio__input:focus:not(:focus-visible)::before{content:none}.cosmos-radio__input:focus::before{border-radius:calc(9999px * 1.5);bottom:calc((4px + 0px) * -1);box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 0px) * -1);position:absolute;right:calc((4px + 0px) * -1);top:calc((4px + 0px) * -1);content:\"\"}.cosmos-radio__input::after{box-sizing:content-box;content:\"\";display:block;height:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);position:absolute;top:50%;transform:translateY(-50%);width:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);z-index:1}.cosmos-radio__input~.cosmos-radio__dot{border-radius:9999px;display:block;height:6px;left:0;margin:auto;opacity:0;position:absolute;right:0;top:50%;transform:translateY(-50%);width:6px}.cosmos-radio__input:checked~.cosmos-radio__dot{opacity:1}.cosmos-radio__content{min-width:0;position:relative}.cosmos-radio__content--row{width:100%}.cosmos-radio__content--row label{width:100%}.cosmos-radio__label{display:block;min-width:0;position:relative}.cosmos-radio__label::before{bottom:calc(calc(0.25 * var(--cosmos-radio-size, 16px)) * -1);content:\"\";left:0;position:absolute;right:0;top:calc(calc(0.25 * var(--cosmos-radio-size, 16px)) * -1)}.cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color);--cosmos-text-font-family:var(--cosmos-radio-font-family);--cosmos-text-font-size:var(--cosmos-radio-font-size);--cosmos-text-font-style:var(--cosmos-radio-font-style);--cosmos-text-font-weight:var(--cosmos-radio-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-line-height);--cosmos-text-text-transform:var(--cosmos-radio-text-transform);display:flex;position:relative}.cosmos-radio--hovered .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color-hover)}.cosmos-radio--appearance-dark{color:var(--cosmos-radio-color, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input{background:var(--cosmos-radio-background-color, transparent);border-color:var(--cosmos-radio-border-color, rgba(0, 15, 30, 0.6))}.cosmos-radio--appearance-dark .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input:checked~.cosmos-radio__dot{background-color:var(--cosmos-radio-dot-color, #FFFFFF)}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover,.cosmos-radio--appearance-dark.cosmos-radio--hovered{color:var(--cosmos-radio-color-hover, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-dark.cosmos-radio--hovered .cosmos-radio__input{background:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-dark.cosmos-radio--hovered .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.8))}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input:checked{border-color:transparent}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input{border-color:var(--cosmos-radio-border-color-hover, rgba(0, 15, 30, 0.6))}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input:checked{border-color:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-radio--appearance-light{color:var(--cosmos-radio-color, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input{background:var(--cosmos-radio-background-color, transparent);border-color:var(--cosmos-radio-border-color, rgba(255, 255, 255, 0.6))}.cosmos-radio--appearance-light .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input:checked~.cosmos-radio__dot{background-color:var(--cosmos-radio-dot-color, #000F1E)}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover,.cosmos-radio--appearance-light.cosmos-radio--hovered{color:var(--cosmos-radio-color-hover, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-light.cosmos-radio--hovered .cosmos-radio__input{background:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-light.cosmos-radio--hovered .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.8))}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input:checked{border-color:transparent}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-light:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input{border-color:var(--cosmos-radio-border-color-hover, rgba(255, 255, 255, 0.6))}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-light:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input:checked{border-color:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-radio--disabled{pointer-events:none}.cosmos-radio--disabled .cosmos-radio__prefix{opacity:0.4}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__input{border-color:var(--cosmos-radio-border-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__input{border-color:var(--cosmos-radio-border-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--invalid .cosmos-radio__input{border-color:var(--cosmos-radio-invalid-color, #E06600);border-width:var(--cosmos-radio-border-width, 2px)}";

const generateClassNames = bem('cosmos-radio');
const CosmosRadio$1 = /*@__PURE__*/ proxyCustomElement(class CosmosRadio extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inputchangeEvent = createEvent(this, "inputchange", 6);
        this.inputinvalidEvent = createEvent(this, "inputinvalid", 7);
        /**
         * Sets the Radio into a checked state.
         */
        this.checked = false;
        /**
         * Disables the Radio.
         */
        this.disabled = false;
        /**
         * Indicates that the Radio can receive focus.
         */
        this.focusable = true;
        /**
         * Defines the interactive hit area that responds to pointer events in order to change the Radio's checked state.
         */
        this.hitArea = 'content';
        /**
         * Sets the Radio into an invalid state.
         */
        this.invalid = false;
        /**
         * Marks the Radio and its associated group as mandatory to be checked in order to submit a form.
         */
        this.required = false;
        this.computedAppearance = 'dark';
        this.inputInvalid = false;
        this.isHovered = false;
        this.labelText = '';
        this.tabIndex = 0;
        this.radios = [];
        this.hoveredOn = () => {
            this.isHovered = true;
        };
        this.hoveredOff = () => {
            this.isHovered = false;
        };
        this.handleFormData = (event) => {
            if (!!this.name && this.input && this.input.checked && !this.disabled) {
                return event.formData.append(this.input.name, this.input.value);
            }
        };
        this.handleFormSubmit = (event) => {
            const isValid = this.reportValidity();
            if (!isValid) {
                event.preventDefault();
            }
        };
        this.handleInvalid = (event) => {
            if (this.group) {
                // Disable the native validation tooltip
                event.preventDefault();
            }
            this.inputInvalid = true;
            this.inputinvalidEvent.emit();
        };
        this.handleChange = () => {
            var _a;
            // Sync of checked property will emit an `inputchange` event
            this.checked = (_a = this.input) === null || _a === void 0 ? void 0 : _a.checked;
        };
        this.handleSlotChange = () => {
            this.labelText = getDefaultSlotTextContent(this.defaultSlotRef);
        };
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
    }
    handleFocusableChange(newValue) {
        this.setTabindexFromFocusable(newValue);
    }
    handleInvalidChange(newValue) {
        this.inputInvalid = newValue;
    }
    handleCheckedChange(checked, oldChecked) {
        if (checked && checked !== oldChecked) {
            this.inputchangeEvent.emit();
        }
    }
    /**
     * Returns the validity status of the Radio's value.
     * Fires an `inputinvalid`  event in the case of invalidity.
     */
    async inputCheckValidity() {
        return this.checkValidity();
    }
    /**
     * Performs the same validity checking steps as the `inputCheckValidity` methods.
     * Fires an `inputinvalid` event and reports the problem to the user in case of invalidity.
     */
    async inputReportValidity() {
        return this.reportValidity();
    }
    /**
     * Sets a custom error message for the native validation issue report.
     */
    async inputSetCustomValidity(message) {
        var _a;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.setCustomValidity(message);
    }
    /**
     * Sets focus on the Radio. This will scroll the element into the view and focus it.
     */
    async inputFocus() {
        var _a;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.focus();
    }
    /**
     * Removes focus from the Radio.
     */
    async inputBlur() {
        var _a;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.blur();
    }
    deriveTextAppearance() {
        return this.computedAppearance === 'light' ? 'light' : 'dark';
    }
    getTitle() {
        var _a;
        return this.clamp ? (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim() : undefined;
    }
    checkValidity() {
        var _a, _b;
        // Check if any of the radios in the group is checked
        const isRadioGroupChecked = (_a = this.radios) === null || _a === void 0 ? void 0 : _a.some((radio) => {
            return radio.shadowRoot.querySelector('input[type="radio"]').checked;
        });
        // Check if any of the radios in the group is required
        const isRadioGroupRequired = (_b = this.radios) === null || _b === void 0 ? void 0 : _b.some((radio) => {
            return radio.required;
        });
        // Determine the validity based on the group rather than the individual radio
        return !isRadioGroupRequired || isRadioGroupChecked;
    }
    reportValidity() {
        const isValid = this.checkValidity();
        if (!isValid && this.input) {
            // To report the validity on an individual radios, we need to set the input to required
            this.input.required = true;
            this.input.reportValidity();
        }
        return isValid;
    }
    getAllRadios() {
        if (!this.group) {
            return [this.element];
        }
        const radios = [
            ...this.group.querySelectorAll(`${transformTagName('cosmos-radio')}[name="${this.name}"]`),
        ];
        return radios.filter((item) => !item.disabled);
    }
    getRadioIndex() {
        return this.radios.findIndex((radio) => radio === this.element);
    }
    setTabindexFromFocusable(isFocusable = this.focusable) {
        this.tabIndex = isFocusable ? 0 : -1;
    }
    connectedCallback() {
        this.form = this.element.closest('form');
        this.group = this.element.closest(transformTagName('cosmos-radio-group'));
        if (this.form) {
            this.form.addEventListener('formdata', this.handleFormData, true);
            this.form.addEventListener('submit', this.handleFormSubmit, true);
        }
    }
    componentWillLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
        this.radios = this.getAllRadios();
        this.radioIndex = this.getRadioIndex();
        this.setTabindexFromFocusable();
    }
    componentDidLoad() {
        slotMutationService.observe(this.element, this.handleSlotChange);
    }
    disconnectedCallback() {
        if (this.form) {
            this.form.removeEventListener('formdata', this.handleFormData);
            this.form.removeEventListener('submit', this.handleFormSubmit);
        }
        slotMutationService.unobserve(this.element);
    }
    render() {
        return (h("div", { key: '36284693ae93be337adad245f2193d64b931f709', class: generateClassNames({
                appearance: this.computedAppearance,
                disabled: this.disabled,
                hovered: this.isHovered,
                invalid: this.invalid || this.inputInvalid,
            }), part: "base" }, h("div", { key: 'b0cafc7810617c172178d70f79ef5ad1450520e9', class: generateClassNames('input-and-prefix') }, h("cosmos-text", { key: 'b9f3b381c6c842f6fce0de99a9ac118b687832fb', "aria-hidden": "true", class: generateClassNames('aligner'), size: "small", tag: "span" }), h("div", { key: 'f4405978bd745a10ca3e6dcb3388ad154cbb14db', class: generateClassNames('input-container') }, h("input", { key: 'f388b8b9a132d128e643500b190d9fed9a3e7a2b', "aria-label": this.labelText, "aria-posinset": this.radioIndex + 1, "aria-setsize": this.radios.length, autofocus: this.autofocus, checked: this.checked, class: generateClassNames('input'), disabled: this.disabled, id: "radio", name: this.name, onInvalid: this.handleInvalid, ref: (el) => (this.input = el), required: this.required, tabIndex: this.tabIndex, type: "radio", value: this.value, onChange: this.handleChange, part: "radio" }), h("span", { key: '5c01b6f512e6a06e7e177c046c584632eff6974e', class: generateClassNames('dot') })), h("label", { key: 'bb0c2f8fcdc2572ad5ad2bcee44075b8db86cc76', "aria-hidden": "true", htmlFor: "radio", class: generateClassNames('prefix'), onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff, part: "prefix" }, h("slot", { key: '31d9d0ab48c66f72d43299780a98a48669f35021', name: "prefix" }))), h("div", { key: '66e3e18cefb432b744429ae0033a78056c8b617d', class: generateClassNames('content', {
                row: this.hitArea === 'row',
            }) }, h("label", { key: '0d8cd2f078022b2146a48f4d76eb3b66111ab440', class: generateClassNames('label'), htmlFor: "radio" }, h("cosmos-text", { key: 'bcf5592827d5bb8c51bd2155eb0a210918d36839', appearance: this.deriveTextAppearance(), class: generateClassNames('label-text'), clamp: this.clamp, onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff, size: "small", tag: "span", title: this.getTitle(), exportparts: "base: label" }, h("span", { key: '0931b484545fd7311423601794e6b927ed7c6ef4' }, h("slot", { key: '1ef7a641e03370e27534007b6a701117d0323142', ref: (el) => (this.defaultSlotRef = el) })))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"],
        "focusable": ["handleFocusableChange"],
        "invalid": ["handleInvalidChange"],
        "checked": ["handleCheckedChange"]
    }; }
    static get style() { return cosmosRadioCss; }
}, [1, "cosmos-radio", {
        "appearance": [513],
        "autofocus": [516],
        "checked": [516],
        "clamp": [516],
        "disabled": [516],
        "focusable": [516],
        "hitArea": [513, "hit-area"],
        "invalid": [516],
        "name": [513],
        "required": [516],
        "value": [513],
        "computedAppearance": [32],
        "inputInvalid": [32],
        "isHovered": [32],
        "labelText": [32],
        "tabIndex": [32],
        "inputCheckValidity": [64],
        "inputReportValidity": [64],
        "inputSetCustomValidity": [64],
        "inputFocus": [64],
        "inputBlur": [64]
    }, undefined, {
        "appearance": ["handleAppearanceChange"],
        "focusable": ["handleFocusableChange"],
        "invalid": ["handleInvalidChange"],
        "checked": ["handleCheckedChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-radio", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-radio":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosRadio$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosRadio = CosmosRadio$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosRadio, defineCustomElement };
